
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("5YJ1A", function(module, exports) {

$parcel$export(module.exports, "FeedbackNudge", () => $26669968f7401daf$export$b05b391cfd27dc1c);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $8Bc5A = parcelRequire("8Bc5A");

var $cZ5k3 = parcelRequire("cZ5k3");

var $70G5B = parcelRequire("70G5B");

var $jh7Cg = parcelRequire("jh7Cg");

var $cE2Qr = parcelRequire("cE2Qr");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4C8El = parcelRequire("4C8El");


var $dsvCp = parcelRequire("dsvCp");

var $4HB2o = parcelRequire("4HB2o");
const $26669968f7401daf$export$b05b391cfd27dc1c = ({ children: children })=>{
    (0, $4C8El.useTrackMountedNudgesController)((0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const shouldShowNudge = (0, $dsvCp.useCanShowQuickstartNudge)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { setHasNudgeActive: setHasNudgeActive }] = (0, $cE2Qr.useQuickstartActions)();
    const markComplete = (0, $jh7Cg.useMarkAsCompleteAndExpand)();
    const onFinishClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'finishNudgeButton clicked', {
            nudgeId: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5)
        });
        setHasNudgeActive(false, (0, $8Bc5A.JWM_FEEDBACK_TASK));
        markComplete((0, $8Bc5A.JWM_FEEDBACK_TASK));
    }, [
        createAnalyticsEvent,
        markComplete,
        setHasNudgeActive
    ]);
    if (!shouldShowNudge) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $70G5B.QuickstartNudge), {
        nudgeId: (0, $dbbf68c32d8c4308$export$e9e47a7ad42e71f5),
        itemNames: [
            (0, $8Bc5A.JWM_FEEDBACK_TASK)
        ],
        nudgeSpotlightCardProps: {
            content: formatMessage((0, $4HB2o.default).jwmFeedbackNudgeContentSpork),
            width: (0, $8Bc5A.DEFAULT_NUDGE_WIDTH),
            position: (0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-5788-spotlight-help-button') ? (0, $cZ5k3.POSITION_LEFT_START) : (0, $cZ5k3.POSITION_BOTTOM),
            // Now that this is attached to the Help button in the topNav, we need to position the message to the left
            actionsBeforeElement: '1/1',
            actions: [
                {
                    text: formatMessage((0, $4HB2o.default).nudgeCtaFinish),
                    onClick: onFinishClick
                }
            ]
        }
    }, children);
};

});
parcelRegister("cZ5k3", function(module, exports) {

$parcel$export(module.exports, "POSITION_RIGHT", () => $450da094f06efa02$export$4ed9c122bcc20157);
$parcel$export(module.exports, "POSITION_BOTTOM", () => $450da094f06efa02$export$cec9b06edc71d96c);
$parcel$export(module.exports, "POSITION_TOP_START", () => $450da094f06efa02$export$3409cd2decbff80c);
$parcel$export(module.exports, "POSITION_TOP_END", () => $450da094f06efa02$export$1a430e6e8a1cbf17);
$parcel$export(module.exports, "POSITION_BOTTOM_START", () => $450da094f06efa02$export$663d1c5ad4215eb0);
$parcel$export(module.exports, "POSITION_BOTTOM_END", () => $450da094f06efa02$export$9c417155181792ae);
$parcel$export(module.exports, "POSITION_RIGHT_START", () => $450da094f06efa02$export$84a134a88de18270);
$parcel$export(module.exports, "POSITION_LEFT_START", () => $450da094f06efa02$export$b67243f02ceac890);
$parcel$export(module.exports, "POSITION_LEFT_END", () => $450da094f06efa02$export$9ed28c4aa79d6398);
$parcel$export(module.exports, "DEFAULT_SCROLL_TO_NUDGE", () => $450da094f06efa02$export$27ce92ea48cacd56);
const $450da094f06efa02$export$b0758137ee643e7 = 'left';
const $450da094f06efa02$export$4ed9c122bcc20157 = 'right';
const $450da094f06efa02$export$cec9b06edc71d96c = 'bottom';
const $450da094f06efa02$export$4fb34bdcd97adf85 = 'top';
const $450da094f06efa02$export$3409cd2decbff80c = 'top-start';
const $450da094f06efa02$export$1a430e6e8a1cbf17 = 'top-end';
const $450da094f06efa02$export$663d1c5ad4215eb0 = 'bottom-start';
const $450da094f06efa02$export$9c417155181792ae = 'bottom-end';
const $450da094f06efa02$export$84a134a88de18270 = 'right-start';
const $450da094f06efa02$export$b71f6a080452c5e8 = 'right-end';
const $450da094f06efa02$export$b67243f02ceac890 = 'left-start';
const $450da094f06efa02$export$9ed28c4aa79d6398 = 'left-end';
const $450da094f06efa02$export$27ce92ea48cacd56 = {
    scrollIntoViewOptions: {
        inline: 'end',
        behavior: 'smooth'
    }
};

});

parcelRegister("70G5B", function(module, exports) {

$parcel$export(module.exports, "QuickstartNudge", () => $f933fdd38ff12453$export$bd61ee610c74db6c);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $bBbEG = parcelRequire("bBbEG");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $f933fdd38ff12453$var$LazyQuickstartNudge = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("1bml9")).then((exportedModule)=>exportedModule.QuickstartNudge), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/onboarding/onboarding-quickstart-core/src/common/ui/quickstart-nudge/main.tsx"
});
const $f933fdd38ff12453$export$bd61ee610c74db6c = ({ children: children = null, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: "quickstartNudge",
        fallback: children,
        attributes: {
            nudgeId: props.nudgeId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-quickstart-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f933fdd38ff12453$var$LazyQuickstartNudge, props, children)));

});
parcelRegister("1bml9", function(module, exports) {

let $0dc825d2270e907f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0dc825d2270e907f$var$load("gevvp").then(()=>parcelRequire('kzsDP'));

});


parcelRegister("jh7Cg", function(module, exports) {

$parcel$export(module.exports, "useMarkAsCompleteAndExpand", () => $7c50ede22a760353$export$5894bc689b58a859);

var $2NMNM = parcelRequire("2NMNM");

var $cE2Qr = parcelRequire("cE2Qr");

var $52Vcw = parcelRequire("52Vcw");
const $7c50ede22a760353$export$5894bc689b58a859 = ()=>{
    const [completedTaskList, { nextMarkAsCompletedTask: nextMarkAsCompletedTask, nextAutoExpand: nextAutoExpand }] = (0, $cE2Qr.useCompletedTaskList)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (taskId)=>{
        const taskAlreadyCompleted = completedTaskList.includes(taskId);
        if (taskAlreadyCompleted) return;
        nextMarkAsCompletedTask(taskId);
        (0, $52Vcw.fireAnalyticsOnChecklistItemCompleted)(createAnalyticsEvent, taskId);
        nextAutoExpand();
    };
};

});

parcelRegister("4C8El", function(module, exports) {

$parcel$export(module.exports, "useTrackMountedNudgesController", () => $8f1de547694da4ce$export$b759b5124fe0d138);

var $5uXOq = parcelRequire("5uXOq");

var $cE2Qr = parcelRequire("cE2Qr");
const $8f1de547694da4ce$export$b759b5124fe0d138 = (nudgeId)=>{
    const [, { addMountedNudge: addMountedNudge, removeMountedNudge: removeMountedNudge }] = (0, $cE2Qr.useQuickstartActions)();
    (0, $5uXOq.useEffect)(()=>{
        addMountedNudge(nudgeId);
        return ()=>{
            removeMountedNudge(nudgeId);
        };
    }, [
        addMountedNudge,
        nudgeId,
        removeMountedNudge
    ]);
};

});

const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';

parcelRegister("dsvCp", function(module, exports) {

$parcel$export(module.exports, "useCanShowQuickstartNudge", () => $6331d14932d8e8e2$export$b687eb4905cdc15a);

var $heI7y = parcelRequire("heI7y");
const $6331d14932d8e8e2$export$b687eb4905cdc15a = ()=>{
    const [{ hasOpened: hasOpened }] = (0, $heI7y.useHasOpened)();
    return hasOpened;
};

});
parcelRegister("heI7y", function(module, exports) {

$parcel$export(module.exports, "useHasOpened", () => $c02ba9c4f48115f2$export$cbaabcded53b5c1f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $h97QA = parcelRequire("h97QA");
const $c02ba9c4f48115f2$var$actions = {
    setHasOpened: $h97QA.setHasOpened
};
const $c02ba9c4f48115f2$var$initialState = {
    hasOpened: false
};
const $c02ba9c4f48115f2$var$Store = (0, $iXqE5.createStore)({
    initialState: $c02ba9c4f48115f2$var$initialState,
    actions: $c02ba9c4f48115f2$var$actions,
    name: 'jsw-onboarding-quickstart-has-opened'
});
const $c02ba9c4f48115f2$export$cbaabcded53b5c1f = (0, $3sQ5x.createHook)($c02ba9c4f48115f2$var$Store);

});
parcelRegister("h97QA", function(module, exports) {

$parcel$export(module.exports, "setHasOpened", () => $68011af9f70af395$export$c4743c64a7c42294);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $68011af9f70af395$export$c4743c64a7c42294 = ()=>({ getState: getState, setState: setState })=>{
        const { hasOpened: hasOpened } = getState();
        if (hasOpened === true) // if state has been updated already return
        return;
        setState({
            hasOpened: true
        });
    };
var $68011af9f70af395$export$2e2bcd8739ae039 = $68011af9f70af395$export$c4743c64a7c42294;

});



parcelRegister("4HB2o", function(module, exports) {

$parcel$export(module.exports, "default", () => $a623af476de2b880$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a623af476de2b880$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    jwmFeedbackNudgeContentSpork: {
        "id": "software-onboarding-nudges--next.jwm-feedback.jwm-feedback-nudge-content-spork",
        "defaultMessage": "Give us your feedback here."
    },
    nudgeCtaFinish: {
        "id": "software-onboarding-nudges--next.jwm-feedback.nudge-cta-finish",
        "defaultMessage": "Finish"
    }
});

});



//# sourceMappingURL=async-feedback-onboarding-nudge.4af99ab0.js.map
